module.exports = __webpack_public_path__ + "media/images/vp/icon.star.red-9cd530511ac82c2c3fbe08df07a3917d.svg";